import React, { memo } from "react";
import SingleBlogHeroSection from "../SingleBlogPage/components/SingleBlogHeroSection/SingleBlogHeroSection";
import Location from "../SingleBlogPage/components/locationComponent/Location";
// import { Link, useParams } from "react-router-dom";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import LinksShowingBlogTitle from "./LinksShowingBlogTitle";
import TableOfContents from "./TableOfContents";
import { Helmet } from "react-helmet-async";
import BlogContent from "./BlogContent";
import Carousel from "../SingleBlogPage/BlogsCarousel";
import { blogArray } from "../../blog";

// const bluearrow =
//   "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/SingleBlogImg/bluearrows.svg";
const PageForCities = ({ blog }) => {
  // const { slug } = useParams();
  // const [singleBlog, setSingleBlog] = useState({});

  // const blog = cityBlogArray.find(
  //   (b) => slugify(b.title, { lower: true, strict: true }) === slug
  // );
  // console.log("checking blog", blog);

  // console.log(blog);

  if (!blog) {
    return <p>Blog not found</p>;
  }
  // console.log(blog.jsonLd);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(blog.jsonLd)}
        </script>
        <title>{blog.title}</title>
        <meta name="description" content={blog.description} />
        {/* <meta name="keywords" content={blog.keywords} /> */}
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.description} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={blog.image} />
        <meta property="og:url" content={blog.url} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Hirestar.io"></meta>
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:type" content={blog.imageType} />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={blog.description} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={blog.description} />
        <meta name="twitter:image" content={blog.image} />
        <meta name="robots" content="index, follow" />
        <meta name="twitter:creator" content="@Hirestar.io" />
        <meta property="article:published_time" content={blog.publishedTime} />
        <link rel="canonical" href={blog.url} />
      </Helmet>

      <div className="section">
        <SingleBlogHeroSection />
      </div>

      {blog.state && (
        <Location
          indiaMap={blog?.big_map}
          stateMap={blog?.small_map}
          state={blog.state}
        />
      )}

      <LinksShowingBlogTitle title={blog.title} />
      {blog.tableContents ? (
        <TableOfContents tableContents={blog.tableContents} />
      ) : (
        <div className=" flex justify-start max-w-5xl  mx-auto px-4 mb-8 lg:px-0 md:px-6">
          <img src={blog.image} className="object-cover w-full  h-[400px]" />
        </div>
      )}

      <BlogContent content={blog.htmlDiscription || blog.htmlContent} />
      <Carousel blogArray={blogArray} />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
};

export default memo(PageForCities);
